<template>
  <div class="gadget">
    <div v-show="false && showHideButton" class="hide_gadget" @click="hideGadget"></div>
    <div class="gadget-contents">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GadgetBase',
  props: {
    showHideButton: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
    }
  },
  methods: {
    hideGadget () {
      this.$emit('hide')
    },
  },
}
</script>

<style scoped>
.gadget {
  width: 100%;
  height: 100%;
  min-height: 100px;
  box-sizing: border-box;
  transition-property: width;
  transition-duration: .1s;
}

.gadget.on {
  opacity: 0.95;
  z-index: 999;
}
.gadget .hide_gadget {
  position: absolute;
  width: 26px;
  height: 26px;
  top: 0;
  right: 4px;
  background-color: #CCC;
  border-radius: 50%;
  z-index: 1;
  cursor: pointer;
  display: none;
}
.dashboard.edit :not(.hidden) .gadget .hide_gadget {
  display: block;
}
.gadget .hide_gadget:before,
.gadget .hide_gadget:after {
  content: '';
  position: absolute;
  display: block;
  width: 16px;
  height: 2px;
  background-color: #FFF;
  top: 50%;
  left: 50%;
  margin: -1px 0 0 -8px;
  z-index: 1;
  pointer-events: none;
}
.gadget .hide_gadget:before {
  transform: rotate(-45deg);
}
.gadget .hide_gadget:after {
  transform: rotate(45deg);
}

.gadget-contents {
  background-color: #FFF;
  box-sizing: border-box;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.1);
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/GadgetBase.vue